import { CollegeProduct } from "data/data";
import React,{ FC } from "react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import ModalQuickView from "./ModalQuickView";
import Prices from "./Prices";

export interface ProductCardProps {
  className?: string;
  data: CollegeProduct;
}
const ProductCard: FC<ProductCardProps> = ({
  className = "",
  data,
}) => {
  const {
    id,
    name,
    price,
    type,
    image,
    price_html,
    promotion_label,
  } = data;
  const link = type === 'grouped' ? `/grouped-detail?id=${id}` : `/product-detail?id=${id}`
  const [showModalQuickView, setShowModalQuickView] = React.useState(false);

  return (
    <>
      <div
        className={`nc-ProductCard relative flex flex-col bg-transparent ${className}`}
        data-nc-id="ProductCard"
        onClick={() => window.scrollTo(0, 0)}
      >
        <Link to={link} className="absolute inset-0"></Link>

        <div className="relative flex-shrink-0 bg-slate-50 dark:bg-slate-300 rounded-3xl overflow-hidden z-1 group">
          <Link to={link} className="block">
            <NcImage
              containerClassName="flex aspect-[11/12] w-full"
              src={image}
              className="object-cover w-full h-full drop-shadow-xl"
            />
          </Link>

          {promotion_label != null && (
            <div className="ribbon">
              {promotion_label}
            </div>
          )}
        </div>

        <div className="space-y-4 px-2.5 pt-5 pb-2.5">
          <div>
            <h2
              className={`nc-ProductCard__title text-base font-semibold transition-colors`}
            >
              {name}
            </h2>
          </div>

          <div className="flex justify-between items-end ">
            <Prices price={price} price_html={price_html} />
          </div>
        </div>
      </div>

      {/* QUICKVIEW */}
      <ModalQuickView
        show={showModalQuickView}
        onCloseModalQuickView={() => setShowModalQuickView(false)}
      />
    </>
  );
};

export default ProductCard;
